import { createSlice } from '@reduxjs/toolkit';

import type { PayloadAction } from '@reduxjs/toolkit';

type WebAppState = {
  ehrMode: boolean;
  eduChatbotSessionId: string;
};

const initialState = {
  ehrMode: false,
  eduChatbotSessionId: '',
} as WebAppState;

const slice = createSlice({
  name: 'webApp',
  initialState,

  reducers: (create) => ({
    setEhrMode: create.reducer(
      (state, { payload: ehrMode }: PayloadAction<boolean>) => {
        state.ehrMode = ehrMode;
      }
    ),

    setEduChatbotSessionId: create.reducer(
      (state, { payload: eduChatbotSessionId }: PayloadAction<string>) => {
        state.eduChatbotSessionId = eduChatbotSessionId;
      }
    ),
  }),
});

export const { setEhrMode, setEduChatbotSessionId } = slice.actions;

export default slice.reducer;
